export const DISCOVERY_SUCCESS_MODAL_COMPONENT = 'Discovery Success Modal';
export const DISCOVERY_SUCCESS_QUERY_PARAM = 'showDiscoverySuccess';
export const POST_PUBLISH_MODAL_QUERY_PARAM = 'showPostPublishModal';
export const MARKETING_DISCOVERY_UTILS = 'marketing-discovery-utils';
export let USER_ATTRIBUTES;

/**
 * Result types returned by the backend.
 */
(function (USER_ATTRIBUTES) {
  USER_ATTRIBUTES["HasSeenStudioBetaAnnouncementModal"] = "MarketingDiscoveryUtils:HasSeenStudioBetaAnnouncementModal";
})(USER_ATTRIBUTES || (USER_ATTRIBUTES = {}));
export const resultTypes = ['SOCIAL_POST', 'SCAFFOLDED_MARKETING_EMAIL', 'FORM'];